import { render } from "./instagram.svg?vue&type=template&id=73f93dd0"
const script = {}
script.render = render

export default script